import React, { useState, useEffect } from "react";
import CardFormVas from "./cardFormVas";
import Loading from "./loading";
import { awsApiCotizacionVas } from "../Services/AwsService";
import ModalGenerateSimulacion from "./modalGenerateSimulacion";
import {
  cleanTablePdfVAS,
  sendDataForPdfVAS,
  selectResponseVAS,
  cleanTablePdf,
  cleanTablePdfIG,
} from "../Store/secureInvestmentIncome/actions";
import { API } from "aws-amplify";
import { getMonths } from "../Utils/utils";
import { ToastContainer } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { addRecommended } from "../Store/recommended/actions";
import HookFormVas from "./hookFormVas";
import { decryptEstandar } from "../Utils/CryptographyUtils";
import { removeAll, removeAssured } from "../Store/data/actions";
import { callToAPIQuote, validateValuesInQuote } from "../Utils/validators";
import ModalRetakeAsessory from "../Components/modalRetakeAsessory";
import IconAtomsClose from "../Resources/svg/Icons/IconAtomsClose";

async function handlerDataApi({
  request,
  userLogin,
  dispatch,
  values,
  assured,
  contratant,
}) {
  return callToAPIQuote({
    values,
    request,
    active: true,
    onDispatch: (resData, response) => {
      resData.assured = assured;
      resData.contratant = contratant;
      dispatch(sendDataForPdfVAS(resData));
      dispatch(selectResponseVAS(response));
    },
    userLogin,
  });
}

export default function ModalFormVAS({
  open,
  close,
  id_product,
  dataState,
  idProspecto,
  investmentProfile,
}) {
  const [state, setState] = useState({
    items: {},
    openTablePdf: false,
    showSimulate: true,
    tableSimulate: [],
    idQuote: "",
    idComponent: null,
  });

  const [isLoading, setisLoading] = useState(false);
  const [percentCC, setPersentCC] = useState([]);
  const [isClear, setIsClear] = useState(false);
  const [alert, setAlert] = useState(false);
  const pdfValues = useSelector((state) => state.cotizador.valuesPdfVAS);
  const idUser = useSelector((state) => decryptEstandar(state.login.idClient));
  const userLogin = useSelector((state) =>
    decryptEstandar(state.login.username)
  );
  const briefcase = useSelector((state) => state.briefcase.selectBriefcase);
  const portafolio = useSelector((state) => state.cotizador.portafolio);
  const activeBtn = useSelector((state) => state.cotizador.btnPdfVAS);
  const dispatch = useDispatch();
  const [openModalMessage, setOpenModalMessage] = useState(false);

  const closeModal = () => {
    close(id_product);
    setState((prevState) => ({
      ...prevState,
      showSimulate: true,
    }));
  };

  const openModalPdf = () =>
    setState((prevState) => ({ ...prevState, openTablePdf: true }));
  const onCloseModalPdf = () =>
    setState((prevState) => ({ ...prevState, openTablePdf: false }));
  const toggleSimulate = (idComponent) =>
    setState((prevState) => ({
      ...prevState,
      showSimulate: !prevState.showSimulate,
      idComponent,
    }));

  const { items, openTablePdf, showSimulate, idComponent } = state;

  let validate = validateValuesInQuote({ pdfValues });
  const verifyValuesInPdf = async (values) => {
    if (validate) {
      await getDataMacroExcel(values);
    }
  };

  const getDataMacroExcel = async (values) => {
    setisLoading(true);

    setState((prevState) => ({
      ...prevState,
      items: {},
      tableSimulate: [],
    }));

    let codigo = briefcase.codigo;

    const { assured, contratant } = dataState;

    let request = awsApiCotizacionVas({
      ...values,
      ...(contratant && Object.keys(contratant).length > 0
        ? contratant
        : assured),
      codigo,
      months: getMonths(),
      idProspecto,
      idUser,
    });

    const { error, resData } = await handlerDataApi({
      request,
      userLogin,
      dispatch,
      values,
      briefcase,
      portafolio,
      assured,
      contratant,
    });

    if (!error) {
      setState((prevState) => ({ ...prevState, items: resData }));
    }

    setisLoading(false);
  };

  const getPercentCC = async () => {
    const response = await API.get("api-rentas", "/producto/configmin/AS");
    if (response.porcCesionComision) {
      setPersentCC(response.porcCesionComision);
    }
  };
  const handleClear = () => {
    setOpenModalMessage(true);
  };

  const handleOpen = () => {
    setOpenModalMessage(false);
    closeModal();
    setIsClear(true);
    dispatch(addRecommended({}));
    dispatch(cleanTablePdfVAS());
    dispatch(cleanTablePdf());
    dispatch(cleanTablePdfIG());
  };

  const handleClose = () => {
    setOpenModalMessage(false);
  };

  const cleanPdfVas = () => {
    dispatch(cleanTablePdfVAS());
  };

  useEffect(() => {
    if (isClear && Object.keys(dataState).length > 1) {
      dispatch(removeAll());
    } else if (isClear && Object.keys(dataState).length === 1) {
      dispatch(removeAssured());
    }
    if (validate) {
      setAlert(false);
    } else {
      setAlert(true);
    }
    if (open) {
      document.getElementsByTagName("body")[0].style.overflow = "hidden";
    } else {
      document.getElementsByTagName("body")[0].style.overflow = "auto";
    }
    getPercentCC();
  }, [isClear, validate, open]);

  const [modalDataIG, setModalDataIG] = useState({
    items: {},
    openTablePdf: false,
    showSimulate: true,
    tableSimulate: [],
    idQuote: "",
    idComponent: null,
  });

  return (
    <div className={`modalFormRG  ${open ? "is-open" : ""}`}>
      <div className="modalFormRG__container">
        <div className="modalFormRG__container__button" onClick={closeModal}>
          <span>Cerrar</span>
          <IconAtomsClose />
        </div>
        <HookFormVas
          investmentProfile={investmentProfile}
          submitValues={verifyValuesInPdf}
          openModalPdf={openModalPdf}
          listPercentCC={percentCC}
          dataState={dataState}
          onClick={() => handleClear()}
          isError={alert}
          setState={setModalDataIG}
        />
        <ModalGenerateSimulacion
          open={openTablePdf}
          onCloseModalPdf={onCloseModalPdf}
          cleanTablePdf={cleanPdfVas}
          items={pdfValues}
          activeBtn={activeBtn}
          id_product={id_product}
        />
        <CardFormVas
          items={items}
          openModalPdf={openModalPdf}
          showSimulate={toggleSimulate}
          goTo={showSimulate}
          idComponent={idComponent}
        />
        <ToastContainer containerId={"A"} />
      </div>
      {isLoading && <Loading  />}
      <ModalRetakeAsessory
        open={openModalMessage}
        setOpen={setOpenModalMessage}
        title="¿Estas seguro?"
        subtitleMessage="Al limpiar datos perderás las cotizaciones que generaste."
        messageAlert="Si quieres volver a cotizar deberás ingresar nuevamente el número de DNI de tu cliente; la plataforma solo guardará su perfil de inversión."
        firstButtonText="CANCELAR"
        secondButtonText="CONFIRMAR"
        firstButtonFunction={handleClose}
        secondButtonFunction={handleOpen}
      />
    </div>
  );
}
